/**
 *
 */
(function () {
  'use strict';
  angular
    .module('cbl.finanza.mf.directives')
    .directive('cblCalendar', [
      '$parse',
      'FIN_CONSTANTS',
      function ($parse, CONSTANTS) {
        return {
          restrict: 'E',
          require: 'ngModel',
          scope: {
            value: '=ngModel',
            placeholder: '=',
            ngRequired: '=',
            ngDisabled: '=',
            minDate: '=',
            maxDate: '=',
            ngClass: '=',
            cblChange: '=',
            name: '='
          },
          templateUrl:
            CONSTANTS.BASE_ROOT + 'widgets/cblCalendar/cblCalendar.html',
          controller: [
            '$scope',
            function ($scope) {
              $scope.minDate = $scope.minDate ? $scope.minDate : null;
              $scope.maxDate = $scope.maxDate ? $scope.maxDate : null;

              if ($scope.value && $scope.value.length === 10) {
                $scope.value = new Date($scope.value + 'T02:00:00');
              } else {
                try {
                  if ($scope.value) {
                    $scope.value = new Date($scope.value);
                  }
                } catch (e) {
                  // $scope.value = null;
                  console.log('Date not valid for that value: ' + $scope.value);
                }
              }

              $scope.apri = function ($event) {
                $scope.opened = true;
              };

              $scope.opened = false;

              $scope.dateOptions = {
                formatYear: 'yy',
                startingDay: 1,
                formatMonth: 'MM'
              };
              $scope.formats = [
                'dd-MM-yyyy',
                'yyyy/MM/dd',
                'dd.MM.yyyy',
                'shortDate'
              ];
              $scope.format = $scope.formats[0];
            }
          ],
          link: link
        };

        function link(scope, element, attr, ctrls) {
          ctrls.$formatters.unshift(function (value) {
            // format check
            if (value && scope.value && !(scope.value instanceof Date)) {
              var dateArray = value.split('-');
              if (dateArray[0].length === 4) {
                value = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
              }
              dateArray = value.split('-');
              scope.value = new Date(
                dateArray[2],
                dateArray[1] - 1,
                dateArray[0].substr(0, 2)
              );
            }
            return value;
          });
        }
      }
    ])
    .directive('cblCalendarValidator', [
      function () {
        return {
          restrict: 'A',
          require: 'ngModel',
          link: link
        };

        function link(scope, element, attr, ctrls) {
          element.on('keyup', function (evt) {
            if (evt.which === 8 || evt.keyCode === 8) {
              if (this.value.length === 5 || this.value.length === 2) {
                this.value = this.value.substr(0, this.value.length - 1);
              }
              return;
            }
            this.value = this.value.replace(/[^0-9\-]/g, '');
            var v = this.value;
            if (v.match(/^\d{2}$/) !== null) {
              this.value = v + '-';
            } else if (v.match(/^\d{2}\-\d{2}$/) !== null) {
              this.value = v + '-';
            }
            this.value = this.value.replace(/\-\-/g, '-');
            if (this.value.length > 10) {
              this.value = this.value.substr(0, 10);
            }
          });

          // For DOM -> model validation
          ctrls.$parsers.unshift(function (value) {
            var minDate = scope.minDate;
            // minDate Validation
            ctrls.$setValidity('minDate', true);
            if (!minDate || !value) {
              return value;
            }

            var dateArray = value.split('-');
            if (dateArray.length < 2) {
              ctrls.$setValidity('minDate', false);
              return value;
            }
            var dateTime = new Date(
              dateArray[2],
              dateArray[1] - 1,
              dateArray[0],
              12
            );
            if (dateTime.getTime() < minDate.getTime()) {
              ctrls.$setValidity('minDate', false);
            }
            return value;
          });

          // For DOM -> model validation
          ctrls.$parsers.unshift(function (value) {
            var maxDate = scope.maxDate;
            // maxDate Validation
            ctrls.$setValidity('maxDate', true);
            if (!maxDate || !value) {
              return value;
            }

            var dateArray = value.split('-');
            if (dateArray.length < 2) {
              ctrls.$setValidity('maxDate', false);
              return value;
            }
            var dateTime = new Date(
              dateArray[2],
              dateArray[1] - 1,
              dateArray[0]
            );
            if (dateTime.getTime() > maxDate.getTime()) {
              ctrls.$setValidity('maxDate', false);
            }
            return value;
          });

          ctrls.$parsers.unshift(function (value) {
            if (scope.cblChange) {
              scope.cblChange(value);
            }
            return value;
          });

          ctrls.$formatters.unshift(function (value) {
            // format check
            if (value) {
              var dateArray = value.split('-');
              if (dateArray[0].length === 4) {
                value = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
              }
            }
            if (scope.cblChange) {
              scope.cblChange(value);
            }

            return value;
          });

          // For model -> DOM validation
          ctrls.$formatters.unshift(function (value) {
            var minDate = scope.minDate;
            // minDate Validation
            ctrls.$setValidity('minDate', true);
            if (!minDate || !value) {
              return value;
            }

            var dateArray = value.split('-');
            if (dateArray.length < 2) {
              ctrls.$setValidity('minDate', false);
              return value;
            }
            var dateTime = new Date(
              dateArray[2],
              dateArray[1] - 1,
              dateArray[0],
              12
            );
            if (dateTime.getTime() < minDate.getTime()) {
              ctrls.$setValidity('minDate', false);
            }
            return value;
          });

          // For model -> DOM validation
          ctrls.$formatters.unshift(function (value) {
            var maxDate = scope.maxDate;
            // maxDate Validation
            ctrls.$setValidity('maxDate', true);
            if (!maxDate || !value) {
              return value;
            }

            var dateArray = value.split('-');
            if (dateArray.length < 2) {
              ctrls.$setValidity('maxDate', false);
              return value;
            }
            var dateTime = new Date(
              dateArray[2],
              dateArray[1] - 1,
              dateArray[0]
            );
            if (dateTime.getTime() > maxDate.getTime()) {
              ctrls.$setValidity('maxDate', false);
            }
            return value;
          });
        }
      }
    ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/cblCalendar/cblCalendarDrct.js
 ** module id = 39
 ** module chunks = 1 2
 **/